import { GlobalEnv } from './index'
import { trim } from '../utils/format'
import { mergeObj, getExprVal } from '../utils/merge-obj'

/**
 * 获取格式化的语言信息
 * @param {*} lang 语言
 * @param {*} langMessages 语音信息
 * @returns
 */
export const getformateLangMessage = (langMessages, lang) => {
  if (!langMessages || typeof langMessages !== 'object') {
    return langMessages
  }
  lang = lang || GlobalEnv.lang
  let langMessage = trim(langMessages[lang])
  if (langMessage) {
    return langMessage
  }
  langMessage =
    langMessages[lang.replace('-', '_')] ||
    langMessages[lang.replace('-', '_').toLowerCase()]
  return trim(langMessage)
}

/**
 * 获取业务线下的apollo配置
 * @param  productType 业务线类型
 * @param {
 * apolloData: apollo数据
 * searchKey: 要查找key,支持"obj.a.b"
 * }
 * @returns
 */
export const getProdConfFromApollo = (
  productType,
  { apolloData, searchKey, module = 'product_conf' } = {}
) => {
  if (productType && typeof productType === 'object') {
    apolloData = productType.apolloData
    searchKey = productType.searchKey
    module = productType.module
    productType = undefined
  }
  if (!module) {
    module = 'product_conf'
  }
  if (!apolloData) {
    apolloData = GlobalEnv.apolloData
  }
  searchKey = searchKey?.trim?.()
  const prodConf = apolloData?.[module] || {}
  const commonApollo = prodConf['0'] || prodConf[Number(0)] || {}
  if (!searchKey && !productType) {
    return commonApollo
  }
  const productTypeApollo =
    prodConf[String(productType)] || prodConf[Number(productType)] || {}
  if (searchKey) {
    const startTime = new Date().getTime()
    const productVal = getExprVal(searchKey, productTypeApollo)
    let endVal = productVal
    if (typeof productVal === 'undefined') {
      endVal = getExprVal(searchKey, commonApollo)
    } else if (productVal && typeof productVal === 'object') {
      endVal = mergeObj(getExprVal(searchKey, commonApollo), productVal, {
        needNew: true,
      })
    }
    // 字符串统一去前后空格
    if (typeof endVal === 'string') {
      endVal = endVal?.trim?.()
    }
    console.log(
      `【getProdConfFromApollo1】-computed-end-${
        new Date().getTime() - startTime
      }`,
      productType,
      endVal
    )
    return endVal
  }
  // 同一个productType只处理一次merge操作
  if (productTypeApollo.mergedFlag) return productTypeApollo
  const startTime = new Date().getTime()
  mergeObj(productTypeApollo, commonApollo, { notCoverTarget: true })
  //  const productTypeApollo = mergeObj(commonApollo, productTypeApollo, {needNew: true})
  productTypeApollo.mergedFlag = true
  console.log(
    `【getProdConfFromApollo】-computed-end-${
      new Date().getTime() - startTime
    }`,
    productType,
    productTypeApollo
  )
  return productTypeApollo
}
